import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  
  to {
    opacity: 0;
    transform: translateY(-8px);
  }
`;

const scaleIn = keyframes`
  0% {
    transform: scale(0.95);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const scaleOut = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(0.95);
    opacity: 0;
  }
`;

export const Wrapper = styled("div")(({ theme, active, $width, $centered }) => ({
  display: active ? "flex" : "none",
  justifyContent: "center",
  position: "absolute",
  top: "calc(100% + 8px)",
  right: 0,
  zIndex: 151,
  width: "100%",
  minWidth: $width || "100%",
  cursor: "default",

  ...($centered && {
    right: "50%",
    transform: "translateX(50%)",
    width: "auto",
  }),

  "& > *": {
    userSelect: "none",
  },
}));

export const DropdownBlock = styled("div")(
  ({ theme, noPadding, $width }) => ({
    display: "block",
    backgroundColor: theme.palette.header.dropdownBg,
    borderRadius: "14px",
    padding: noPadding ? 0 : "8px",
    boxShadow: `0 10px 40px ${theme.palette.header.dropdownShadow}, 0 2px 6px ${theme.palette.header.shadow}`,
    border: `1px solid ${theme.palette.header.dropdownBorder}`,
    width: $width || "100%",
    backdropFilter: "blur(20px)",
    transformOrigin: "top right",
  }),
  css`
    animation: ${props => (props.active ? scaleIn : scaleOut)} 0.2s cubic-bezier(0.4, 0, 0.2, 1) forwards,
      ${props => (props.active ? fadeIn : fadeOut)} 0.2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  `
);
